import { CheckboxInput } from "components";
import {
  Autocomplete,
  Chip,
  CircularProgress,
  styled,
  TextField,
  Box,
} from "@mui/material";

const AutoCompleteWithSearch = ({
  loading,
  disabled,
  size,
  label,
  value,
  options,
  optionLabel,
  uniqueKey,
  onChange,
  inputValue,
  onInputChange,
  width,
  height,
  multiple,
  hasMore,
  setQueryParams,
  isOptionEqualToValue,
  placeholder,
  disabledKey,
  dropdownHeight,
  ...rest
}) => {
  const handleScroll = event => {
    const listboxNode = event.currentTarget;

    const bottom =
      Math.ceil(listboxNode.scrollTop + listboxNode.clientHeight) >=
      listboxNode.scrollHeight - 1;

    if (bottom && !loading && hasMore) {
      setQueryParams(prev => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };
  const handleOnChange = (event, newValue) => {
    const updatedValue = multiple
      ? [
          ...value.filter(option => option?.[disabledKey] === false),
          ...newValue.filter(option => option?.[disabledKey] !== false),
        ]
      : newValue;

    onChange(updatedValue);
  };

  return (
    <AutoCompleteComponent
      size={size || "small"}
      multiple={multiple}
      loading={loading}
      disabled={disabled}
      options={options}
      value={value}
      onChange={handleOnChange}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            size="small"
            key={`${index}`}
            label={option?.[optionLabel]}
            {...getTagProps({ index })}
            disabled={disabledKey && !option?.[disabledKey]}
          />
        ))
      }
      getOptionLabel={option => option?.[optionLabel] || ""}
      inputValue={inputValue}
      onInputChange={(_, newInputValue, reason) => {
        onInputChange(newInputValue, reason);
      }}
      isOptionEqualToValue={(option, value) =>
        isOptionEqualToValue
          ? isOptionEqualToValue(option, value)
          : option?.id === value?.id
      }
      renderOption={(props, option, { selected }) => (
        <Box
          component="li"
          {...props}
          key={option[uniqueKey] || option?.[optionLabel]}
        >
          {multiple ? (
            <CheckboxInput label={option?.[optionLabel]} checked={selected} />
          ) : (
            option?.[optionLabel]
          )}
        </Box>
      )}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      ListboxProps={{
        onScroll: handleScroll,
        style: {
          maxHeight: dropdownHeight || 300,
          overflow: "auto",
        },
      }}
      width={width}
      height={height}
      {...rest}
    />
  );
};

const AutoCompleteComponent = styled(Autocomplete)(({ width, height }) => ({
  width: width || 300,
  height: height,
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: "#F3F4F6",
    cursor: "not-allowed",
  },
}));

export default AutoCompleteWithSearch;
